import { ComponentSectionsNlSub } from "../../../graphql/generated/graphql";

import { Headline } from "../../typography/Headline";
import { NewsletterForm } from "./NewsletterForm";

export interface INewsletter {
  variation?: "full" | "small";
}
export function Newsletter({
  title,
  html,
  privacy,
  askForFirstName,
  askForLastName,
}: ComponentSectionsNlSub & INewsletter) {
  const privacyPagePath = privacy?.data?.attributes?.path;

  return (
    <div className="newsletter-wrapper">
      <div className="mx-auto lg:py-0 lg:gap-24 lg:grid lg:grid-cols-5 ">
        <div className="newsletter-content-wrapper lg:col-span-3">
          <div className="mb-4">
            <Headline text={title || ""} variant="h2" />
          </div>
          <div
            className="prose mt-3"
            dangerouslySetInnerHTML={{ __html: html || "" }}
          />
        </div>
        <div className="newsletter-form-wrapper lg:col-span-2 flex items-center">
          <NewsletterForm
            variation="block"
            privacyPagePath={privacyPagePath}
            askForFirstName={askForFirstName || false}
            askForLastName={askForLastName || false}
          />
        </div>
      </div>
    </div>
  );
}
